export default __webpack_public_path__ + "static/image-four-07715f439bc781153e4e627789aeb00f.png";